export const sortItems = <Item, Key extends keyof Item>(
  items: Item[],
  // No custom order: absent, null from legacy clients, or a shape this build does not know.
  order: Item[Key][] | null | undefined,
  key: Key,
): Item[] => {
  const itemOrder = Array.isArray(order) ? order : [];
  const orderMap = itemOrder.reduce<Record<string, number>>(
    (acc, value, index) => {
      acc[value as string] = index;
      return acc;
    },
    {},
  );
  const orderedItems = items.filter((item) => itemOrder.includes(item[key]));
  const leftOverItems = items.filter((item) => !itemOrder.includes(item[key]));

  return [
    ...orderedItems.slice().sort((a, b) => {
      const aOrder = orderMap[a[key] as string];
      const bOrder = orderMap[b[key] as string];
      return aOrder - bOrder;
    }),
    ...leftOverItems,
  ];
};
